/**
 * Feed API — the merged notes+digests stream the chat home reads on
 * every poll (every 8 s while visible — see ADR 0005).
 *
 * Pagination is cursor-based: `before` is the `created_at` of the oldest
 * item already loaded (the server echoes it as `next_cursor`). Cursors
 * stay stable while new items land at the head — the previous offset
 * scheme shifted under the reader and could skip a window mid-scroll.
 */
import { request } from "./client";
import type { FeedResponse } from "../lib/types";

export interface FetchFeedOptions {
  /** ISO `created_at` cursor — return items strictly older than this. */
  before?: string;
  signal?: AbortSignal;
}

export async function fetchFeed(
  limit: number,
  { before, signal }: FetchFeedOptions = {},
): Promise<FeedResponse> {
  const params = new URLSearchParams({ limit: String(limit) });
  if (before) {
    params.set("before", before);
  }
  return request<FeedResponse>(`/api/v1/feed?${params.toString()}`, {
    method: "GET",
    signal,
  });
}
